<template>
  <HelpModal :link="link" :info="info" :currentStep="currentStep">
    <div
      for="info-modal"
      class="
        z-50
        fixed
        cursor-pointer
        flex flex-col
        items-center
        justify-center
        rounded-full
        w-[10rem]
        h-[10rem]
        bottom-8
        right-8
      "
    >
      <img class="hover:" src="/img/help.png" />
      <p
        class="block p-2 text-base font-bold text-center xl:hidden text-neutral rounded-box animate-pulse"
      >
        Besion d'aide ?<br />
        Cliquez moi
      </p>
      <div
        class="
          absolute
          xl:flex
          flex-col
          gap-y-1
          top-4
          rotate-[135deg]
          right-28
          hidden
        "
      >
        <div class="w-2 h-2 rounded-full bg-neutral"></div>
        <div class="w-4 h-4 rounded-full bg-neutral"></div>
        <div class="w-6 h-6 rounded-full bg-neutral"></div>
      </div>
      <p
        class="absolute top-0 hidden p-2 text-base font-bold text-center xl:block bg-neutral text-neutral-content rounded-box -left-24 animate-pulse"
      >
        Besion d'aide ?<br />
        Cliquez moi
      </p>
    </div>
  </HelpModal>
</template>

<script>
import HelpModal from "@/components/HelpModal.vue";
import authMixin from "@/utils/mixins/auth.mixin.js";
export default {
  name: "Help",
  components: { HelpModal },
  mixins: [authMixin],
  props: {
    link: String,
    info: Object,
    currentStep: Number
  },
  data() {
    return {
      demo: false,
      demolink: ""
    };
  }
};
</script>

<style></style>
